export const messages = {
  en: {
    shopAppraiseManage: {
      title: 'Shop Appraise Management',
      queryConditions: 'Query Conditions',
      productName: 'Product Name',
      user: 'User',
      score: 'Score',
      content: 'Content',
      images: 'Images',
      commentTime: 'Comment Time',
      operations: 'Operations',
      reply: 'Reply',
      search: 'Search',
      reset: 'Reset',
      productComments: 'Product Comments'
    }
  },
  zh: {
    shopAppraiseManage: {
      title: '商品评价管理',
      queryConditions: '查询条件',
      productName: '商品名称',
      user: '用户',
      score: '评分',
      content: '内容',
      images: '图片',
      commentTime: '评论时间',
      operations: '操作',
      reply: '回复',
      search: '查询',
      reset: '重置',
      productComments: '商品评论'
    }
  }
}